<template>
  <v-container :class="{ v3_index_view: $vuetify.breakpoint.mdAndUp }">
    <v-row>
      <v-col>
        <span class="headline font-weight-light">
          Zahtjevi
        </span>
      </v-col>
    </v-row>
    <v-row v-if="demandsCount === 0">
      <v-col>
        <v-alert type="info" color="blue darken-1">
          Nemate zahtjeva.
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-else justify="center">
      <v-col cols="12" sm="9" lg="7">
        <v-card
          v-for="demand in demands"
          :key="demand.id"
          class="mb-6"
          outlined
          :class="{ 'd-none': !demand.demandable }"
        >
          <div v-if="demand.demandable">
            <v-card-title class="d-flex justify-space-between">
              <span v-if="demand.column_name === 'locked_subjects'"
                >Otključavanje predmeta</span
              >
              <span v-if="demand.column_name === 'official'"
                >Brisanje dokumenta</span
              >
            </v-card-title>
            <v-card-subtitle class="text-subtitle-1 pb-0">
              <!-- <p class="mb-0" v-if="demand.demandable_type === 'Diploma'">
                                <span class="font-weight-light">
                                    Tip dokumenta:
                                </span> 
                                {{ (demand.demandable.semester === 1) ? 'Izvještaj na polugodištu' : ''}}
                            </p> -->
              <p class="mb-0">
                <span class="font-weight-light">
                  Zahtjev podnio:
                </span>
                {{ demand.creator ? demand.creator.full_name : "" }}
              </p>
              <p class="mb-0">
                <span class="font-weight-light">
                  Za učenika:
                </span>
                {{ demand.demandable.user ? demand.demandable.user.full_name : "" }}
              </p>
              <p class="mb-0">
                <span class="font-weight-light">
                  Odjeljenje:
                </span>
                <span>
                  {{ demand.demandable.department ? demand.demandable.department.label : "" }}
                </span>
              </p>
            </v-card-subtitle>
            <v-divider class="mx-3 mt-3"></v-divider>
            <v-card-text class="text-body-1">
              <span class="font-weight-light">
                Razlog:              </span>
              {{ demand.reason }}
            </v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-btn
                    color="primary"
                    depressed
                    block
                    height="44"
                    class="text-none"
                    @click="changeDemandStatus(demand.id, 1)"
                  >
                    <v-icon class="mr-2">mdi-check</v-icon>
                    Prihvati
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-btn
                    color="error"
                    depressed
                    block
                    height="44"
                    outlined
                    class="text-none"
                    @click="openDialog(demand.id)"
                  >
                    <v-icon class="mr-2">mdi-close-circle-outline</v-icon>
                    Odbij
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- <v-row v-if="canLoadMore">
            <v-col class="d-flex justify-center">
                <v-btn
                    depressed
                    class="text-none"
                    color="primary"
                    height="44"
                    @click="getDemands"
                >
                    <v-icon class="mr-2">mdi-plus</v-icon>
                    Učitaj više
                </v-btn>
            </v-col>
        </v-row> -->

    <v-dialog v-model="dialog" width="500" @click:outside="dialog = false">
      <v-card>
        <v-card-title primary-title>
          Jeste li sigurni?
        </v-card-title>

        <v-card-text class="pt-5">
          Jeste li sigurni da želite odbiti ovaj zahtjev?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="dialog = false"
            class="text-none"
            depressed
            large
            outlined
            >Odustani</v-btn
          >
          <v-btn
            @click="changeDemandStatus(demandId, 0)"
            color="error"
            class="text-none"
            depressed
            large
          >
            Potvrdi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ApiV2 from "@/services/ApiV2";
import { serverBus } from "@/main";

export default {
  components: {},
  data: () => ({
    demands: [],
    dialog: false,
    demandId: null,
    canLoadMore: false,
    demandsCount: null,
    page: 1,
  }),

  created() {
    this.getDemands();
  },

  methods: {
    getDemands() {
      ApiV2.get("demands", {
        params: {
          with: ["creator", "demandable.user", "demandable.department"],
          sortBy: "created_at",
          sortDesc: true,
          perPage: -1,
        },
      })
        .then((response) => {
          this.demands = response.data.data;
          // this.canLoadMore = (response.data.current_page % response.data.last_page) !== 0;
          this.demandsCount = response.data.total;
          serverBus.$emit("change-demands-count", this.demandsCount);
        })
        .finally(() => {
          this.page++;
        });
    },

    openDialog(demandId) {
      this.dialog = true;
      this.demandId = demandId;
    },

    changeDemandStatus(demandId, value) {
      ApiV2.post(`demands/${demandId}/confirm`, {
        allowed: value,
      })
        .then(() => {
          if (value === 0) {
            this.dialog = false;
          }
          this.getDemands();
          serverBus.$emit("show-snackbar", true);
        })
        .catch(() => {
          serverBus.$emit("show-snackbar", false);
        });
    },
  },
};
</script>
